// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3pwyV","large":"styles_large__AheKD"};